import React from "react";
import { connect } from "react-redux";

import NextGenVisitsMissing from "./NextGenVisitsMissing";

const NextGenVisitsMissingContainer = props => {
  return <NextGenVisitsMissing {...props} />;
};

const mapStateToProps = state => {
  return {
    token: state.auth.token
  };
};

export default connect(mapStateToProps)(NextGenVisitsMissingContainer);



// WEBPACK FOOTER //
// src/pages/NextGenDashboard/NextGenVisitsMissing.container.js